import { render, staticRenderFns } from "./testimony-item.vue?vue&type=template&id=96c9c772&scoped=true&"
import script from "./testimony-item.vue?vue&type=script&lang=js&"
export * from "./testimony-item.vue?vue&type=script&lang=js&"
import style0 from "./testimony-item.vue?vue&type=style&index=0&id=96c9c772&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c9c772",
  null
  
)

export default component.exports